export default {"src":"/_next/static/media/layer-fill.60144ad2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};